import { ref } from 'vue'
import getApiClient from 'src/utils/getApiClient'
import type { HeaderTownSearchResult } from 'src/layouts/core-layout/components/CoreHeader/composables/useHeaderTownSearch'

export type HeaderTownCountry = {
  iso: string
  name: string
  main_page_url: string
}

export default function useHeaderTownMenu() {
  const countries = ref<HeaderTownCountry[]>([])
  const towns = ref<HeaderTownSearchResult[]>([])
  const mainTowns = ref<HeaderTownSearchResult[]>([])
  const axios = getApiClient()
  let loadPromise: Promise<void> | null = null

  function loadTownData() {
    if (loadPromise) {
      return loadPromise
    }

    loadPromise = axios.get('/api/town/menu/')
      .then(response => {
        response.data.towns.forEach((town: HeaderTownSearchResult) => {
          if (town.is_main_town) {
            mainTowns.value.push(town)
            return
          }

          towns.value.push(town)
        })

        countries.value = response.data.other_countries
      })
      .catch(() => {
        loadPromise = null
      })

    return loadPromise
  }

  return {
    countries,
    towns,
    mainTowns,
    loadTownData,
  }
}
